import { PRODUCT_SPEC_DIETARY_CERTIFICATION_FIELDS } from 'pages/qa-spec/constant';

export const isCheckBooleanQaSpec = (value) => {
  return (
    typeof value === 'string' && ['yes', 'no'].includes(value?.toLowerCase())
  );
};

export const isNullOrUndefinedValue = (value) =>
  value === null || value === undefined;

export const getDefaultFormatKeys = () => {
  const certificationKeys = Object.keys(
    PRODUCT_SPEC_DIETARY_CERTIFICATION_FIELDS
  );

  return ['wicCompliant', ...certificationKeys, 'msds', 'glutenFreeClaim'];
};

export const transformStringToBooleanQaSpecValue = (value) => {
  if (isNullOrUndefinedValue(value)) return null;

  return typeof value === 'string' && value?.toLowerCase() === 'yes'
    ? true
    : false;
};

export const transformBooleanToStringQaSpecValue = (value) => {
  if (isNullOrUndefinedValue(value)) return null;

  return value === true ? 'Yes' : 'No';
};

export const transformFormValuesQaSpecToParams = (
  formValues = {},
  additionalKeys = []
) => {
  let result = {};
  let formatKeys = getDefaultFormatKeys().concat(additionalKeys);

  for (const [key, value] of Object.entries(formValues)) {
    result = {
      ...result,
      [key]: formatKeys.includes(key)
        ? transformStringToBooleanQaSpecValue(value)
        : value,
    };
  }

  return result;
};

export const transformInitialDataToFormValues = (
  formValues = {},
  additionalKeys = []
) => {
  let result = {};
  let formatKeys = getDefaultFormatKeys().concat(additionalKeys);

  if (formValues) {
    for (const [key, value] of Object.entries(formValues)) {
      result = {
        ...result,
        [key]: formatKeys.includes(key)
          ? transformBooleanToStringQaSpecValue(value)
          : value,
      };
    }
  }

  return result;
};
